import { render, staticRenderFns } from "./PluseDashboardIcon.vue?vue&type=template&id=451a083e&scoped=true&"
import script from "./PluseDashboardIcon.vue?vue&type=script&lang=js&"
export * from "./PluseDashboardIcon.vue?vue&type=script&lang=js&"
import style0 from "./PluseDashboardIcon.vue?vue&type=style&index=0&id=451a083e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451a083e",
  null
  
)

export default component.exports